export const ADD_DEFAULT_PAYMENT_METHOD = 'ADD_DEFAULT_PAYMENT_METHOD';
export const ADD_NEXTIVA_PLAN = 'ADD_NEXTIVA_PLAN';
export const ADD_CONTACT_INFO = 'ADD_CONTACT_INFO';
export const ADD_NEXTIVA_BILL = 'ADD_NEXTIVA_BILL';
export const ADD_PAYMENT_TYPE_OBJECT = 'ADD_PAYMENT_TYPE_OBJECT';
export const CLEAR_PAYMENT_TYPE_OBJECT = 'CLEAR_PAYMENT_TYPE_OBJECT';
export const CLEAR_NEXTIVA_PLAN = 'CLEAR_NEXTIVA_PLAN';
export const CLEAR_NEXTIVA_BILL = 'CLEAR_NEXTIVA_BILL';
export const CLEAR_DEFAULT_PAYMENT_METHOD = 'CLEAR_DEFAULT_PAYMENT_METHOD';
export const PROCESS_NEXTIVA_BILL = 'PROCESS_NEXTIVA_BILL';
export const SET_PAYMENT_DISABLED = 'SET_PAYMENT_DISABLED';
export const SET_PAYMENT_METHOD_CAPABILITY_ENABLED =
  'SET_PAYMENT_METHOD_CAPABILITY_ENABLED';
